import { HttpClient } from "libs";
import { getAccessToken } from "./tokens";
import { ICustomWindow } from "../types";
import { FastMutex } from "./fastMutex";
import { getCookieLang } from "./detectLanguage";

const myWindow: ICustomWindow = window;

const MUTEX_LOCK_NAME = "requests";
const mutex = new FastMutex({});

const releaseMutex = () => {
	mutex.release(MUTEX_LOCK_NAME);
};

const onRequestCreate = async (request: Request): Promise<any> => {
	const tokenService = myWindow.tokenService;

	let token = getAccessToken();
	if (token) {
		request.headers.set("Authorization", `Bearer ${token}`);
	}
	let lang = getCookieLang();
	if (lang) {
		request.headers.set("Accept-Language", lang);
	}

	if (tokenService.shouldRefresh()) {
		return mutex.lock(MUTEX_LOCK_NAME).then(() => {
			return tokenService
				.refresh()
				.then(({ access_token }) => {
					if (access_token) {
						request.headers.set("Authorization", `Bearer ${access_token}`);
					}
				})
				.catch(console.log)
				.finally(releaseMutex);
		});
	}
};

function createHttp(baseURL: string): HttpClient {
	const client = new HttpClient(baseURL);
	client.on(HttpClient.REQUEST_CREATE, onRequestCreate);

	return client;
}

export const createAppApiClient = (): HttpClient => createHttp(process.env.REACT_APP_API_URL);

export const createChatApiClient = (): HttpClient => {
	return createHttp(process.env.REACT_APP_CHAT_API_URL);
};

export const baseURL = process.env.REACT_APP_API_URL;

export const federationBaseURL = process.env.REACT_APP_FEDERATIONS_API_URL;
